import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'fin-editorial-page-head',
  templateUrl: './editorial-page-head.component.html',
  styleUrls: ['./editorial-page-head.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EditorialPageHeadComponent {
  titleAsHeading = input(true);
  title = input<string>();
}
